import { render, staticRenderFns } from "./AugmentationsTabPublish.vue?vue&type=template&id=275610d8&scoped=true&"
import script from "./AugmentationsTabPublish.vue?vue&type=script&lang=js&"
export * from "./AugmentationsTabPublish.vue?vue&type=script&lang=js&"
import style0 from "./AugmentationsTabPublish.vue?vue&type=style&index=0&id=275610d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275610d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VFlex,VLayout,VTextField})
